import * as Yup from 'yup';
import { timeSchema } from '../../ticketForm/config/ticketFormSchema';

export default Yup.object().shape({
  order_data: Yup.object().shape({
    pickup: Yup.object().shape({
      date: Yup.string().required('Required'),
      time_from: timeSchema().required('Required'),
      time_to: timeSchema().required('Required'),
    }),
    dropoff: Yup.object().shape({
      date: Yup.string().required('Required'),
      time_from: timeSchema().required('Required'),
      time_to: timeSchema().required('Required'),
    }),
  }),
  price: Yup.object().shape({
    amount: Yup.number().required('Required').min(1),
    currency: Yup.string().required('Required'),
  }),
  suggested_price: Yup.object().shape({
    amount: Yup.number().required('Required').min(0),
    currency: Yup.string().required('Required'),
  }),
  operation_details: Yup.object().shape({
    carrier: Yup.string().required('Required'),
    cost: Yup.object().shape({
      amount: Yup.number().min(0),
      currency: Yup.string().required('Required'),
    }),
    details: Yup.string(),
  }),
  quote_costs: Yup.array()
    .nullable()
    .of(
      Yup.object().shape({
        carrier: Yup.object().shape({
          id: Yup.number(),
          name: Yup.string(),
        }),
        cost: Yup.object().shape({
          amount: Yup.number().min(0),
          currency: Yup.string(),
        }),
        bid_id: Yup.number().nullable(),
        comments: Yup.string(),
        route_id: Yup.number(),
        carrier_id: Yup.number(),
      })
    ),
  conditions: Yup.string(),
  price_suggestion_id: Yup.number().nullable(),
});
